<template>
    <div>
        <h1 class="display-heading">Update E-mail Address</h1>
        <p>
            Hi, we have received your request to update your login e-mail address to {{ newEmailAddress }}.
        </p>
        <p>To proceed, please enter your current password to continue:</p>
        <form @submit.prevent="submitUpdateEmailAddress">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group required">
                        <label>Password</label>

                        <input
                            type="password"
                            name="password"
                            data-vv-validate-on="blur"
                            placeholder="Please enter your current password"
                            v-model="form.password"
                            v-validate="'required'"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('password')
                            }"
                            ref="passwordRef"
                        />

                        <div
                            v-show="validationErrors.has('password')"
                            class="invalid-feedback"
                        >{{ validationErrors.first('password') }}</div>
                    </div>
                </div>
            </div>

            <popup-modal
                ref="popupModalInvalid"
                :hasCloseButton="false"
                title="Error"
            >
                <template slot="content">
                    <p v-if="isInvalidUpdateEmailAddress">
                        Invalid update e-mail address request. Please try again.
                    </p>
                    <p>
                        {{ errorMessage }}
                    </p>
                </template>
                <template slot="footer">
                    <button
                        type="button"
                        class="btn btn-primary btn-primary-insv"
                        @click="dismissError"
                    >Okay</button>
                </template>
            </popup-modal>

            <popup-modal
                ref="popupModalSuccess"
                :hasCloseButton="false"
                title="Login E-mail Address Updated!"
            >
                <template slot="content">
                    <p>
                        Successfully updated your e-mail address!.
                    </p>
                    <p>
                        You may now login with your new e-mail address.
                    </p>
                    <p>
                        Login now to continue.
                    </p>
                </template>
                <template slot="footer">
                    <button
                        type="button"
                        class="btn btn-primary btn-primary-insv"
                        @click="backToLoginSuccess"
                    >Login</button>
                </template>
            </popup-modal>

            <button
                @click="submitUpdateEmailAddress"
                class="btn btn-primary btn-primary-insv mr-2"
                type="button"
            >
                Update My Login E-mail Address
            </button>
            <router-link class="btn btn-secondary" :to="{'name': 'login'}">Back to Login</router-link>
        </form>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'UpdateEmailAddress',
    'components': {
        popupModal
    },
    'computed': {
        token () {
            return (this.$route.query && this.$route.query.token) ? this.$route.query.token : '';
        }
    },
    data () {
        return {
            'newEmailAddress': '',
            'form': {
                'password': ''
            },
            'isInvalidUpdateEmailAddress': false,
            'errorMessage': ''
        };
    },
    mounted () {
        if (this.token) {
            this.axios.get('Account/VerifyUpdateEmailAddress', {
                'params': {
                    'token': this.token
                }
            }).catch(() => {
                this.$refs.popupModalInvalid.show();
                this.isInvalidUpdateEmailAddress();
            });
        } else {
            this.$refs.popupModalInvalid.show();
            this.isInvalidUpdateEmailAddress();
        }
    },
    'methods': {
        submitUpdateEmailAddress () {
            this.errorMessage = '';
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    // create reset password request in DB
                    this.axios
                        .post('Account/UpdateEmailAddress', {
                            't': this.token,
                            'p': this.form.password
                        })
                        .then(() => {
                            this.$refs.popupModalSuccess.show();
                        })
                        .catch(({ response }) => {
                            this.$refs.popupModalInvalid.show();
                            this.errorMessage = response.data.message;
                        });
                }
            });
        },
        dismissError () {
            this.$refs.popupModalInvalid.hide();
        },
        backToLoginSuccess () {
            this.$refs.popupModalSuccess.hide().then(() => {
                // Remove token
                Cookies.remove('t');
                this.axios.defaults.headers.common = {};

                this.$store.commit('setAppStatus', true);
                this.axios.get('account/logout')
                    .finally(() => {
                        this.$store.commit('setAppStatus', true);
                        this.$store.commit('clearUserState');
                        this.$router.push({
                            'name': 'login'
                        });
                    });
            });
        },
        dismissPopup () {
            this.$refs.popupModalInvalid.hide();
        }
    }
};
</script>

<style>
</style>
